import { getWcBrand } from '../../../src/worldcup/helpers/wcBrand.helper';

export const getGroupsViewGroupCategory = (): string => getWcBrand().NAME;

export const GROUPS_VIEW_COPY = {
  PAGE_TITLE: 'My Squads',
  CREATE_TITLE: 'Create a Squad',
  JOIN_TITLE: 'Join a Squad',
  COMPANY_GROUP_LABEL: 'Company squad',
  PRIZE_POOL_LABEL: 'Prize pool',
  TOP_PRIZE_LABEL: 'Top prize',
  EMPTY_ICON: '\uD83D\uDC65',
  EMPTY_TITLE: 'No squads yet',
  EMPTY_SUBTITLE:
    'Create a private squad or join with an invite code to compete on your own leaderboard.',
  DISCOVER_TITLE: 'Discover the leaderboard',
  DISCOVER_SUBTITLE: 'Follow every match and see how the tournament unfolds.',
  DISCOVER_CTA: 'Explore now',
} as const;

export const GROUPS_VIEW_RANK_GOLD_BADGE_MAX = 10;
export const GROUPS_VIEW_RECESSED_RANK_MIN = 100;
/** Hex alpha suffix for the discovery section gradient start color. */
export const GROUPS_VIEW_DISCOVERY_GRADIENT_ALPHA = '40';
